import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../services/api'
/* COMPONENTS */
import Button from '../../components/Button'
import Input from '../../components/Input'

/* IMAGES */
import companyIcon from '../../images/png/LOGO-TKG.64714292646d49296c29.jpg'

import animation from '../../images/animated/Animation - 1734311298042.json'

import styled from 'styled-components'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lottie from 'react-lottie';


const CardWrapper = styled.section`
    
    display: flex;
    align-items: center;
    
    .colum_primary{
        display: flex;
        flex:0.7;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }

    .colum_primary > img{
        width: 90%;
        object-fit: contain;
    }

    .colum_secondary{
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex:1;
        align-items: center;
        height: 100vh;
    }

    @media screen and (max-width:720px){

        .colum_primary{
            flex:0;
            display: none;
        }

        .colum_secondary{
            justify-content: center;
            height: 80vh;
        }


    }


`
const Box = styled.div`

    display: flex;
    flex-direction:column;

    input{
        margin-bottom: 1.2rem;
    }

    p{
        font-family: "Poppins";
        font-weight: 500;
        font-size: 1.4rem;
        color: black;
    }

    img{
        width: 130px;
        height: 130px;
        border-radius: 100%;
        object-fit:contain;
        margin-bottom: 1rem;
    }
    
    button{
        margin-top: 1.2rem;
    }

    @media screen and (max-width:720px){
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 90%;

        input{
            width: 100%;
        }

        img{
            width: 150px;
            height: 150px;
        }

        p{
            font-size: 1.5rem;
            margin-top: 1.5rem;
        }
        
    }


`

const Landing = () => {

    const navigate = useNavigate()
    const [animationBtn,setAnimationBtn] = useState(false)
    const [mail,setMail] = useState()
    const [password,setPassword] = useState()

    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: animation,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
    }
    
    const handleLogin = async () => {
        setAnimationBtn(true)
        if(!mail){
            setAnimationBtn(false)
            return toast.error("Informe um email!",{
                autoClose:1200
            })
        }
        if(!password){
            setAnimationBtn(false)
            return toast.error("Informe uma senha!")
        }

        const response = await api.post("session/storage/panel", {

            "mail": mail,
            "password": password


        })

        if (response.status == 200) {

            localStorage.setItem("@USER_NAME", response.data.user.name)
            localStorage.setItem("@USER_TOKEN", response.data.token)
            localStorage.setItem("@USER_PICTURE", response.data.user.picture != null ? response.data.user.picture : false)
            setAnimationBtn(false)
            navigate("/dashboard")
            return
        }

        setAnimationBtn(false)
        return toast.error("Email ou senha inválidos!")




    }

    return (

        <CardWrapper>
        <ToastContainer />
            
            <div className='colum_primary'>
            <Lottie options={defaultOptions}
              height={600}
              width={600}
              />
            </div>

            <div className='colum_secondary'>

                <Box>
                    <img src={companyIcon} />
                    <p>Dados de acesso</p>
                    <Input name="E-mail" onChange={(e) => setMail(e.target.value)}/>
                    <Input name="Senha"  onChange={(e) => setPassword(e.target.value)} type={"password"}/>
                    <Button animation={animationBtn} name={"Entrar"} onClick={() => handleLogin()} />
                </Box>

            </div>

        </CardWrapper>

    )
}

export default Landing